export const TITLE = 'Здравильно'

export const SECRET = 'accessToken'
